import { Component, computed, inject, LOCALE_ID, signal } from '@angular/core';
import { Pagination } from '../../../../shared/ui/shared-tables/pagination/pagination';
import { Tables } from '../../../../shared/ui/shared-tables/tables/tables';
import { ErrorData } from '../../../../utils/error-data/error-data';
import { Loading } from '../../../../utils/loading/loading';
import { Router } from '@angular/router';
import {
  ActionInterface,
  InstaPayAccount,
} from '../../../../pages/admin-dashboard/instapay-accounts/instapay-accounts.model';
import { SuccessfulNotification } from '../../../../utils/successful-notification/successful-notification';

@Component({
  selector: 'app-instapay-list-component',
  imports: [Pagination, Tables, ErrorData, Loading, SuccessfulNotification],
  templateUrl: './instapay-list-component.html',
  styleUrl: './instapay-list-component.scss',
})
export class InstapayListComponent {
  private locale = inject(LOCALE_ID);
  private router = inject(Router);

  isArabic = computed(() => this.locale.startsWith('ar'));
  loading = signal(false);
  errorMessage = signal<string | null>(null);

  accountNumber = $localize`:@@instapayAccountNumber:InstaPay Account Number`;

  createdOnBy = $localize`:@@instapayCreatedOnBy:Created On / By`;

  headerItems = computed(() => [
    {
      key: 'accountNumber',
      label: this.accountNumber,
      width: '38%',
    },
    {
      key: 'createdOnBy',
      label: this.createdOnBy,
      width: '45%',
    },
    {
      key: 'actions',
      label: '',
      type: 'actions',
      width: '17%',
    },
  ]);

  instapayAccounts = signal<InstaPayAccount[]>([
    {
      id: 1,
      accountNumber: '12345678902',
      createdOn: '10/08/2026 09:45 AM',
      createdByEn: 'Mohamed Mahmoud',
      createdByAr: 'محمد محمود',
    },
    {
      id: 2,
      accountNumber: '01123456789',
      createdOn: '10/08/2026 09:45 AM',
      createdByEn: 'Mohamed Ali',
      createdByAr: 'محمد علي',
    },
    {
      id: 3,
      accountNumber: '01012345678',
      createdOn: '10/08/2026 09:45 AM',
      createdByEn: 'Sara Hassan',
      createdByAr: 'سارة حسن',
    },
    {
      id: 4,
      accountNumber: '01234567890',
      createdOn: '01/08/2026 11:15 AM',
      createdByEn: 'Ahmed Ali',
      createdByAr: 'أحمد علي',
    },
    {
      id: 5,
      accountNumber: '01098765432',
      createdOn: '10/08/2026 09:45 AM',
      createdByEn: 'Omar Hassan',
      createdByAr: 'عمر حسن',
    },
    {
      id: 6,
      accountNumber: '01198765432',
      createdOn: '10/08/2026 09:45 AM',
      createdByEn: 'Mona Ahmed',
      createdByAr: 'منى أحمد',
    },
    {
      id: 7,
      accountNumber: '01298765432',
      createdOn: '10/08/2026 09:45 AM',
      createdByEn: 'Ahmed Mohamed',
      createdByAr: 'أحمد محمد',
    },
    {
      id: 8,
      accountNumber: '01055556666',
      createdOn: '10/07/2026 09:30 AM',
      createdByEn: 'Nour Ali',
      createdByAr: 'نور علي',
    },
  ]);

  tableRows = computed(() => {
    return this.instapayAccounts().map((account) => ({
      id: account.id,
      accountNumber: account.accountNumber,
      createdOn: account.createdOn,
      createdBy: this.isArabic() ? account.createdByAr : account.createdByEn,
    }));
  });

  successMessage = signal<string | null>(null);

  actions: ActionInterface[] = [
    {
      id: 1,
      titleAr: 'نسخ',
      titleEn: 'Copy',
    },
    {
      id: 2,
      titleAr: 'حذف',
      titleEn: 'Delete',
    },
  ];

  async handleAction(event: any) {
    const row = event.entity;
    if (event.actionId === 1) {
      try {
        await navigator.clipboard.writeText(row.accountNumber);
        this.successMessage.set($localize`:@@instapayAccountCopiedSuccessfully:InstaPay account copied successfully.`);
        setTimeout(() => {
          this.successMessage.set(null);
        }, 3000);
      } catch (error) {
        console.error('Failed to copy   ', error);
      }
    }
    if (event.actionId === 2) {
      //handle del
    }
  }

  currentPage = signal(1);
  itemsPerPage = signal(25);
  // totalItems = signal(0);
  totalItems = computed(() => this.tableRows().length);

  pagedRows = computed(() => {
    const start = (this.currentPage() - 1) * this.itemsPerPage();
    const end = start + this.itemsPerPage();

    return this.tableRows().slice(start, end);
  });

  // pagedRows = computed(() => this.tableRows());

  totalPages = computed(() => Math.ceil(this.totalItems() / this.itemsPerPage()));
  startItem = computed(() => (this.totalItems() ? (this.currentPage() - 1) * this.itemsPerPage() + 1 : 0));
  endItem = computed(() => Math.min(this.currentPage() * this.itemsPerPage(), this.totalItems()));

  getPageNumbers() {
    const pages: number[] = [];

    for (let i = 1; i <= this.totalPages(); i++) {
      pages.push(i);
    }

    return pages;
  }
  onPreviousPage() {
    if (this.currentPage() > 1) {
      this.currentPage.update((page) => page - 1);
    }
  }

  onNextPage() {
    if (this.currentPage() < this.totalPages()) {
      this.currentPage.update((page) => page + 1);
    }
  }

  onGoToPage(page: number) {
    this.currentPage.set(page);
  }

  onChangePageNumber(size: number) {
    this.itemsPerPage.set(+size);
    this.currentPage.set(1);
  }

  onPageSizeChange() {
    this.currentPage.set(1);
  }
}
